var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"720"},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},[_c('customer-form',{attrs:{"isUpdating":_vm.isUpdating},on:{"handle-change":function($event){_vm.input = false}},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }